// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"412":"37a763b4","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"412":"d165a0198438a862658f","532":"24e9614fef10a7f0c3d5","678":"439ab1b781c8478dc6d4"}[chunkId] + ".js";
};